import { useEffect, useState } from 'react';
import { db } from 'src/config/firebase';
import { useNavigate, useParams } from 'react-router-dom';
import { useCompanyData } from '../contexts/DataContext';
import getReviews from 'src/api/services/reviews/getReviews';

const useCourseDetails = () => {
  const { data } = useCompanyData();
  const [reviews, setReviews] = useState([]);
  const [contents, setContents] = useState([]);
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { t } = data;

  useEffect(() => {
    const fetchReviews = async (courseId) => {
      const reviews = await getReviews(courseId,'courseId');
      setReviews(reviews);
    };

    const fetchContent = async (courseId) => {
        const content = await  ( await db.ref('CourseContents').orderByChild('courseId').equalTo(courseId).once('value')).val();
        let array = [];
        if(content) {
            Object.values(content).forEach(val=> array.push(val));
        }
        setContents(array)
    };

    fetchReviews(courseId);
    fetchContent(courseId)
  }, [courseId]);

  const handleBooking = (groupId) => {
    const companyId = data?.companyData?.id;
    companyId && navigate(`/booking/${companyId}/${groupId}`);
  };

  const course = data.courses?.find((item) => item.id === courseId);
  return { course, reviews, contents, handleBooking, t };
};

export default useCourseDetails;